import { CALL_API } from 'middlewares/api';
import { url } from 'configs';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_PERMISSIONSEARCHLIST_REQUEST = 'shared/companyspace/permissionSearch/FETCH_PERMISSIONSEARCHLIST_REQUEST';
const FETCH_PERMISSIONSEARCHLIST_SUCCESS = 'shared/companyspace/permissionSearch/FETCH_PERMISSIONSEARCHLIST_SUCCESS';
const FETCH_PERMISSIONSEARCHLIST_ERROR = 'shared/companyspace/permissionSearch/FETCH_PERMISSIONSEARCHLIST_ERROR';

export default function reducer(state = {
  permissionSearchListDatas: [],
  isLoadingList: false,
}, action) {
  switch (action.type) {
    case FETCH_PERMISSIONSEARCHLIST_REQUEST:
      return Object.assign({}, state, {
        isLoadingList: true,
      });
    case FETCH_PERMISSIONSEARCHLIST_SUCCESS:
      return Object.assign({}, state, {
        isLoadingList: false,
        permissionSearchListDatas: action.response.data,
      });
    case FETCH_PERMISSIONSEARCHLIST_ERROR:
      return Object.assign({}, state, {
        isLoadingList: false,
      });
    default:
      return state;
  }
}

export function fetchPermissionSearchList(paramsData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}HRMMiddleware/moduleRoleEmployee`,
      method: 'GET',
      types: [
        FETCH_PERMISSIONSEARCHLIST_REQUEST,
        FETCH_PERMISSIONSEARCHLIST_SUCCESS,
        FETCH_PERMISSIONSEARCHLIST_ERROR,
      ],
      params: paramsData,
    },
  };
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/screens/CompanySpace/screens/PermissionSearch/reducers/index.js
 **/